import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { createSubAdmin } from "../../../services/Auth/AuthService";
import { notifyError, notifyTopRight } from "../Common/Toaster";

const emptyForm = { username: "", email: "", password: "" };
const emptyErrors = { username: "", email: "", password: "" };

export default function SubAdminModal({ show, onHide, onSuccess }) {
  const [formData, setFormData] = useState(emptyForm);
  const [errors, setErrors] = useState(emptyErrors);
  const [loader, setLoader] = useState(false);

  const handleInput = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const resetForm = () => {
    setFormData(emptyForm);
    setErrors(emptyErrors);
  };

  const handleClose = () => {
    resetForm();
    onHide();
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    const errorObj = { ...emptyErrors };
    let hasError = false;

    if (!formData.username.trim()) {
      errorObj.username = "Username is required";
      hasError = true;
    }
    if (!formData.email.trim()) {
      errorObj.email = "Email is required";
      hasError = true;
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email.trim())) {
      errorObj.email = "Enter a valid email";
      hasError = true;
    }
    if (!formData.password.trim()) {
      errorObj.password = "Password is required";
      hasError = true;
    } else if (formData.password.length < 6) {
      errorObj.password = "Password must be at least 6 characters";
      hasError = true;
    }

    setErrors(errorObj);
    if (hasError) return;

    setLoader(true);
    try {
      const response = await createSubAdmin({
        username: formData.username.trim(),
        email: formData.email.trim(),
        password: formData.password,
      });
      notifyTopRight(response?.data?.message || "Sub admin created successfully");
      resetForm();
      onHide();
      onSuccess?.();
    } catch (error) {
      notifyError(error.response?.data?.message || "Failed to create sub admin");
    } finally {
      setLoader(false);
    }
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <form onSubmit={onSubmit}>
        <Modal.Header closeButton>
          <Modal.Title className="fs-20">Create Sub Admin</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="form-group mb-3">
            <label className="text-black font-w500">Username</label>
            <input
              className="form-control"
              name="username"
              value={formData.username}
              onChange={handleInput}
              placeholder="Name"
              autoComplete="off"
            />
            {errors.username && (
              <div className="text-danger fs-12">{errors.username}</div>
            )}
          </div>
          <div className="form-group mb-3">
            <label className="text-black font-w500">Email</label>
            <input
              type="email"
              className="form-control"
              name="email"
              value={formData.email}
              onChange={handleInput}
              placeholder="email@example.com"
              autoComplete="off"
            />
            {errors.email && (
              <div className="text-danger fs-12">{errors.email}</div>
            )}
          </div>
          <div className="form-group mb-3">
            <label className="text-black font-w500">Password</label>
            <input
              type="password"
              className="form-control"
              name="password"
              value={formData.password}
              onChange={handleInput}
              placeholder="••••••"
              autoComplete="new-password"
            />
            {errors.password && (
              <div className="text-danger fs-12">{errors.password}</div>
            )}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            className="btn btn-light"
            onClick={handleClose}
            disabled={loader}
          >
            Cancel
          </button>
          <button type="submit" className="btn btn-primary" disabled={loader}>
            {loader ? "Creating..." : "Create"}
          </button>
        </Modal.Footer>
      </form>
    </Modal>
  );
}
